import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CalculationRunOptions } from '../../../../../../../common/src/options/calculations/calculation-run.options';

@Injectable({
  providedIn: 'root',
})
export class ImportManager {
  public importedModel = new Subject<CalculationRunOptions>();
}
